export const MAXIMUM_SPEED_COLOR = '#0284c7'
export const AVERAGE_SPEED_COLOR = '#ff7f0e'

export const CANVAS_TOP = 24
export const CANVAS_LEFT = 220
export const CANVAS_RIGHT = 30

export const DEFAULT_CHART_HEIGHT = 440
export const MIN_CHART_CANVAS_PX = 180

export const SAMPLE_LIMIT = 10000
